import React, { useState } from 'react';
import { Col , Row, Menu, Icon } from 'antd';
// import Icon from 'antd/lib/icon'
import { Link  , useHistory} from 'react-router-dom';
import Search from './Search';



const {SubMenu} = Menu

function TopNavBar(props) {

  

    const history = useHistory()

    const titleKey = {
        "Dashboard" : "dashboard",
        "Reports" : "reports",
        "Return Orders" : "returnorders",
        "Sales and Collection" : "salesandcollection",
        "Products" : "products",
        "Vehicles" : "vehicles",
        "Warehouses" : "warehouses",
    }

    // const handleClick = (e) => {
    //   setCurrent(e.key)
    // }

    const navigate = (link) =>{ 
        history.push(link)

    }

   
 
    return ( 
            <Row  style={{frontFamily:"Roboto" ,fontSize:"14px" , boxShadow:"rgb(229, 229, 229) 0px 2px 13px 0px"}} >
                <Col  style={{backgroundColor:"#1890ff" , height:"47.5px" , textAlign:"center"}} span={4}>
                   <div style={{ transform: "translateY(-50%)",top:"50%" , position:"relative" , color:"white"}}> {props.title} </div>
                </Col>
                <Col style={{height:"47.5px" }} span={12}>
                    <Row>
                        <Menu  selectedKeys={titleKey[props.title]} mode="horizontal">
                            <Menu.Item  link="dashboard"   key="dashboard"><Link to="/dashboard"> <Icon type="dashboard" />Dashboard </Link> </Menu.Item>
                            <Menu.Item link="reports"   key="reports"><Link to="/reports">  <Icon type="file-text" /> Reports </Link> </Menu.Item>
                                <SubMenu title={<><Icon type="dollar" ></Icon>Sale</>}>
                                {/* <Menu.Item link="customer"  key="salesandcollection"><Link to="/customer">Customer</Link></Menu.Item> */}
                                <Menu.Item link="salesandcollection"  key="salesandcollection"><Link to="/salesandcollection">  Sales & Collection </Link></Menu.Item>
                                <Menu.Item link="returnorders"  key="returnorders"><Link to="/returnorders"> Return Orders</Link></Menu.Item>
                            </SubMenu>
                            <SubMenu title={<><Icon type="home" ></Icon>Inventory</>}>
                                <Menu.Item link="products"  key="products"> <Link to="/products">Products</Link></Menu.Item> 
                                <Menu.Item link="vehicles"  key="vehicles"> <Link to="/vehicles"> Vehicles</Link></Menu.Item> 
                                {/* <Menu.Item link="warehouses"  key="warehouses"><Link to="/warehouses">Warehouses</Link></Menu.Item>  */}
                            </SubMenu>   
                            <SubMenu title={<><Icon type="info" ></Icon>Alerts</>}>
                                <Menu.Item link="alerts/sms"  key="smsAlerts"> <Link to="/alerts/sms/">SMS Alerts</Link></Menu.Item> 
                              
                                {/* <Menu.Item link="warehouses"  key="warehouses"><Link to="/warehouses">Warehouses</Link></Menu.Item>  */}
                            </SubMenu>               
                        </Menu>
                    </Row>
                </Col>
                <Col span={8}>
                    <Search onValueChange={(id)=>navigate(`/sales/order/${id}`)}></Search>
                </Col>
            </Row>
         );
    
}
 
export default TopNavBar;